import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledCategoryLink = styled(Link)({
  textDecoration: "none",
  color: "inherit",
});

export const CategoryCard = styled("div")<{ $isHovered: boolean }>(({ $isHovered }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "white",
  cursor: "pointer",
  padding: 24,
  borderRadius: 24,
  gap: 24,
  border: "1px solid #f0f0f0",
  boxShadow: $isHovered ? "0 12px 28px rgba(108, 92, 231, 0.15)" : "0 2px 8px rgba(0, 0, 0, 0.04)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  transform: $isHovered ? "translateY(-4px)" : "translateY(0)",
  position: "relative",
  overflow: "hidden",
}));

export const BackgroundDecoration = styled("div")({
  position: "absolute",
  top: 0,
  right: 0,
  width: 128,
  height: 128,
  borderRadius: "50%",
  transform: "translate(40px, -40px)",
  transition: "all 0.3s ease",
});

export const IconWrapper = styled("div")<{ $isHovered: boolean }>(({ $isHovered }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(108, 92, 231, 0.08)",
  borderRadius: 16,
  color: "#6C5CE7",
  width: 64,
  height: 64,
  fontSize: 24,
  flexShrink: 0,
  boxShadow: "0 2px 8px rgba(108, 92, 231, 0.1)",
  transform: $isHovered ? "scale(1.1)" : "scale(1)",
  transition: "transform 0.3s ease",
}));

export const ContentWrapper = styled("div")({
  flex: 1,
  position: "relative",
  zIndex: 1,
});

export const CategoryTitle = styled("div")<{ $isHovered: boolean }>(({ $isHovered }) => ({
  fontSize: 18,
  fontWeight: 700,
  marginBottom: 4,
  color: $isHovered ? "#6C5CE7" : "#1f2937",
  transition: "color 0.3s ease",
}));

export const ArrowIcon = styled("div")<{ $isHovered: boolean }>(({ $isHovered }) => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: "rgba(108, 92, 231, 0.08)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#6C5CE7",
  fontSize: 16,
  flexShrink: 0,
  opacity: $isHovered ? 1 : 0,
  transform: $isHovered ? "translateX(0)" : "translateX(16px)",
  transition: "all 0.3s ease",
}));
